import { ReactNode, useMemo, useState } from 'react'
import { Label } from '../../../ui/label'
import { EyeIcon, EyeOffIcon } from 'lucide-react'
import TooltipLabel from './TooltipLabel'

type Props = {
  label?: string
  title?: string
  value?: string | number | boolean | any
  tooltip?: ReactNode
  type?: string
}

export default function Kvp(props: Props) {
  const ChildComponent = useMemo(() => {
    switch (props.type) {
      case 'url':
        return <Url value={props.value} />
      case 'secret':
        return <Secret value={props.value} />
      default:
        return <Text value={props.value} />
    }
  }, [props.type, props.value])

  return (
    <div className="flex flex-col items-start w-full gap-1 group">
      {props.tooltip === undefined ? (
        <Label htmlFor={props.label}>{props.label}</Label>
      ) : (
        <TooltipLabel label={props.label} tooltip={props.tooltip} />
      )}
      {ChildComponent}
    </div>
  )
}

function Text(props: Pick<Props, 'value'>) {
  return <p className="text-secondary font-normal break-all">{props.value}</p>
}

function Secret(props: Pick<Props, 'value'>) {
  const [isHidden, setIsHidden] = useState(true)

  return (
    <div
      className="flex flex-row items-center gap-2 cursor-pointer"
      onClick={() => setIsHidden((prev) => !prev)}
    >
      <p className="flex-1 text-base font-normal break-all text-secondary">
        {isHidden ? '••••••••••••' : props.value}
      </p>

      {isHidden ? (
        <EyeIcon className="w-4 h-4 text-primary" />
      ) : (
        <EyeOffIcon className="w-4 h-4 text-primary" />
      )}
    </div>
  )
}

function Url(props: Pick<Props, 'value'>) {
  return (
    <a
      href={props.value}
      target="_blank"
      rel="noreferrer"
      className="text-base font-normal break-all cursor-pointer text-secondary decoration-dotted underline-offset-4 hover:underline hover:text-accent-foreground"
    >
      {props.value}
    </a>
  )
}
